import { authApi } from '../../utils/api';

export const adminDashboardPage = () => {
    const user = authApi.getCurrentUser();

    if (!user || user.rol !== 'admin') {
        return `
            <section class="page-content">
                <div class="container">
                    <div class="alert alert-danger">
                        <p>Bu sayfaya erişim yetkiniz yok.</p>
                        <a href="/" class="btn-primary">Ana Sayfaya Dön</a>
                    </div>
                </div>
            </section>
        `;
    }

    return `
        <section class="page-content admin-page">
            <div class="container">
                <div class="admin-header">
                    <h1>Admin Paneli</h1>
                    <p>Hoş geldiniz, ${user.ad} ${user.soyad}</p>
                </div>

                <!-- İstatistikler -->
                <div class="admin-stats-grid" id="adminStats">
                    <div class="stat-card"><div class="stat-value" id="statMusteri">-</div><div class="stat-label">Müşteri</div></div>
                    <div class="stat-card"><div class="stat-value" id="statPolice">-</div><div class="stat-label">Aktif Poliçe</div></div>
                    <div class="stat-card stat-warn"><div class="stat-value" id="statBitis">-</div><div class="stat-label">Yaklaşan Bitiş</div></div>
                    <div class="stat-card stat-warn"><div class="stat-value" id="statMuayene">-</div><div class="stat-label">Yaklaşan Muayene</div></div>
                    <div class="stat-card stat-alert"><div class="stat-value" id="statTeklif">-</div><div class="stat-label">Bekleyen Teklif</div></div>
                    <div class="stat-card"><div class="stat-value" id="statBelge">-</div><div class="stat-label">Belge</div></div>
                </div>

                <div class="admin-grid">
                    <a href="/admin/kullanicilar" class="admin-card">
                        <div class="card-icon users-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                        </div>
                        <h3>Kullanıcılar</h3>
                        <p>Müşteri yönetimi</p>
                    </a>

                    <a href="/admin/ruhsatlar" class="admin-card">
                        <div class="card-icon ruhsat-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <rect x="3" y="4" width="18" height="16" rx="2"></rect>
                                <path d="M7 8h10M7 12h6M7 16h8"></path>
                            </svg>
                        </div>
                        <h3>Ruhsatlar</h3>
                        <p>Ruhsat yönetimi ve görsel yükleme</p>
                    </a>

                    <a href="/admin/policeler" class="admin-card">
                        <div class="card-icon police-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                            </svg>
                        </div>
                        <h3>Poliçeler</h3>
                        <p>Sigorta poliçe yönetimi</p>
                    </a>

                    <a href="/admin/teklifler" class="admin-card">
                        <div class="card-icon teklif-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                            </svg>
                        </div>
                        <h3>Teklif Talepleri</h3>
                        <p>Websiteden gelen teklif formları</p>
                    </a>

                    <a href="/admin/muayeneler" class="admin-card">
                        <div class="card-icon muayene-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <circle cx="12" cy="12" r="10"></circle>
                                <polyline points="12 6 12 12 16 14"></polyline>
                            </svg>
                        </div>
                        <h3>Muayene Takibi</h3>
                        <p>Araç muayene tarihi takibi</p>
                    </a>

                    <a href="/admin/belgeler" class="admin-card">
                        <div class="card-icon belge-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                <polyline points="14 2 14 8 20 8"></polyline>
                            </svg>
                        </div>
                        <h3>Belgeler</h3>
                        <p>PDF ve evrak yönetimi</p>
                    </a>

                    <a href="/admin/iptaller" class="admin-card">
                        <div class="card-icon iptal-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="15" y1="9" x2="9" y2="15"></line>
                                <line x1="9" y1="9" x2="15" y2="15"></line>
                            </svg>
                        </div>
                        <h3>İptal İşlemleri</h3>
                        <p>Poliçe iptal takibi</p>
                    </a>
                </div>
            </div>
        </section>
    `;
};
